import { ASSETS_ADD_JS, ASSETS_ADD_CSS } from 'actions/assets';

const DEFAULT_STATE = {
  js: [],
  css: []
};

const dedupe = array => [...new Set(array)];

export default function assets(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case ASSETS_ADD_JS:
      return { ...state, js: dedupe([...state.js, action.uri]) };
    case ASSETS_ADD_CSS:
      return { ...state, css: dedupe([...state.css, action.uri]) };
    default:
      return state;
  }
}
